(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-choose-offer"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('.co-section-offer').forEach(function(sectionEl) {
      var tabBtns = sectionEl.querySelectorAll('.co-tab-btn');
      var carouselGroups = sectionEl.querySelectorAll('.co-carousel-group');
      var bigNumVal = sectionEl.querySelector('.co-big-num-val');
      var bigNumSup = sectionEl.querySelector('.co-big-num-sup');

      function setTab(tabKey, labelText) {
        tabBtns.forEach(function(btn) {
          var active = btn.dataset.tab === tabKey;
          btn.classList.toggle('is-active', active);
          btn.setAttribute(
            'aria-selected',
            active
              ? 'true'
              : 'false'
          );
        });
        carouselGroups.forEach(function(group) {
          var isActive = group.dataset.carousel === tabKey;
          group.classList.toggle('is-active', isActive);
          if (isActive) {
            var comp = group.querySelector('carousel-component');
            if (comp && comp.carousel && typeof comp.carousel.refresh === 'function') {
              try {
                comp.carousel.refresh();
              } catch (e) {}
            }
          }
        });
        if (bigNumVal && labelText) {
          var parts = labelText.trim().split(' ');
          bigNumVal.textContent = parts[0] || '';
          if (bigNumSup) 
            bigNumSup.textContent = parts.slice(1).join(' ') || '';
          
        }
      }

      tabBtns.forEach(function(btn) {
        btn.addEventListener('click', function() {
          setTab(btn.dataset.tab, btn.dataset.label);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      /* this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp); */
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
   /*    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp); */
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        /* if (this.preventHide) return; */
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
